import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViceCaptain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_58_1318)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16 0.650391C24.4776 0.650391 31.3496 7.52243 31.3496 16C31.3496 24.4776 24.4776 31.3496 16 31.3496C7.52243 31.3496 0.650391 24.4776 0.650391 16C0.650391 7.52243 7.52243 0.650391 16 0.650391Z",
			fill: "black",
			stroke: "white",
			strokeWidth: 1.3
		}), /* @__PURE__ */ _jsx("path", {
			d: "M25 8.5L18.9 24.5H13.2L7 8.5H11.2L16 21.4L20.8 8.5H25Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_58_1318",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgViceCaptain;
